<div class="demo-root" [class.demo-root--warmup]="preload && !visible">
    <lib-ai-exam-onboarding-shell [brand]="brand" [progressPercent]="progressPercent"
        [progressLabel]="progressLabel" [showProgress]="visible" [wideCard]="visible">

        @if (visible) {
        <div class="onboarding-card-title" translate>ai-exam-onboarding.demo-video.title</div>
        <p class="onboarding-card-subtitle" translate>ai-exam-onboarding.demo-video.subtitle</p>
        }

        <div class="video-wrap" [class.video-wrap--warmup]="!visible">
            <iframe #demoFrame [src]="demoPageUrl" [title]="demoPageTitle"
                allow="autoplay; fullscreen" (load)="onIframeLoad()"></iframe>
        </div>

        @if (visible) {
        <div class="skip-row">
            <div class="skip-hint" translate>ai-exam-onboarding.demo-video.skip-hint</div>
            <button type="button" class="onboarding-btn-primary" (click)="onReady()">
                <span translate>ai-exam-onboarding.demo-video.ready</span> →
            </button>
        </div>
        }
    </lib-ai-exam-onboarding-shell>
</div>
